export { default } from './CategoryMenuOCP';